import React, { useEffect } from "react";
import { Form, Checkbox, Button, Space } from "antd";

export default function NormasForm({ initialValues, onFinish, onCancel }) {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue(initialValues);
  }, [initialValues, form]);

  return (
    <Form form={form} layout="vertical" onFinish={onFinish} initialValues={initialValues}>
      <Form.Item name="Nom001" valuePropName="checked">
        <Checkbox>
          NOM-001-SEDE-2012
        </Checkbox>
      </Form.Item>

      <Form.Item name="Nom007" valuePropName="checked">
        <Checkbox>NOM-007-ENER-2014</Checkbox>
      </Form.Item>

      <Form.Item name="Nom013" valuePropName="checked">
        <Checkbox>NOM-013-ENER-2013</Checkbox>
      </Form.Item>

      <Form.Item>
        <Space>
          <Button type="primary" htmlType="submit">
            Guardar
          </Button>
          <Button htmlType="button" onClick={onCancel}>
            Cancelar
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
}
